// F-05 files from the web, as the apps do it: the attachment row first (sync decides who may see
// it), then the bytes streamed to R2 through the Worker, then `uploadedAt` for the other devices.
import { newUuidv7 } from '@pf/sync-rules';
import { upload } from '../api.ts';
import { stampNow } from '../clock.ts';
import type { Edit } from '../sync.ts';

export async function attach(
  run: (edits: Edit[]) => Promise<unknown>,
  to: { tripId: string; ownerType: string; ownerId: string; ownerUserId?: string | null; me: string | null },
  file: File,
): Promise<void> {
  const id = newUuidv7();
  const digest = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
  const sha256 = Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
  const owner = to.ownerUserId ?? null;
  await run([
    {
      table: 'attachment',
      id,
      tripId: to.tripId,
      ownerUserId: owner,
      fields: {
        ownerType: to.ownerType,
        ownerId: to.ownerId,
        filename: file.name,
        mime: file.type || null,
        size: file.size,
        sha256,
        createdBy: to.me,
      },
    },
  ]);
  await upload(`/attachments/${id}`, file);
  await run([
    {
      table: 'attachment',
      id,
      tripId: to.tripId,
      ownerUserId: owner,
      fields: { uploadedAt: stampNow() },
    },
  ]);
}
